import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import { useScripts } from '../hooks/useScripts';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { getDomain } from '../utils/getDomain';

function TermsOfService() {
  const domain = getDomain(); // e.g., "vpn111.com"
  const domainName = domain.split('.')[0]; // e.g., "vpn111" from "vpn111.com"
  
  useDocumentTitle('Terms of Service');
  useScripts();
  
  useEffect(() => {
    // Add login-form class to body for proper styling
    document.body.classList.add('login-form');
    
    // Cleanup: remove class when component unmounts
    return () => {
      document.body.classList.remove('login-form');
    };
  }, []);
  
  useEffect(() => {
    // Trigger animations when component mounts
    const triggerAnimations = () => {
      // Dispatch scroll event to trigger css3-animate-it library
      window.dispatchEvent(new Event('scroll'));
      
      // Also manually trigger animations for visible elements
      setTimeout(() => {
        const animatedElements = document.querySelectorAll('.animated');
        animatedElements.forEach((el) => {
          const rect = el.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
          if (isVisible) {
            const originalClasses = el.className;
            el.className = originalClasses.replace(/\banimated\b/g, '').trim();
            void el.offsetHeight; // Force reflow
            setTimeout(() => {
              el.className = originalClasses;
            }, 10);
          }
        });
      }, 100);
    };
    
    // Trigger immediately and after a short delay
    triggerAnimations();
    setTimeout(triggerAnimations, 200);
    setTimeout(triggerAnimations, 500);
  }, []);
  
  return (
    <>
      <section className="bg-form animatedParent" style={{ paddingTop: '60px', paddingBottom: '60px' }}>
        <div className="container">
          <h2 className="text-center" style={{ marginBottom: '40px' }}>Terms of Service</h2>
          <div style={{
            boxSizing: 'inherit',
            marginLeft: 'auto',
            marginRight: 'auto',
            maxWidth: '92%',
            width: '740px',
            fontSize: '20px',
            lineHeight: '1.8',
            color: 'rgb(34, 34, 34)',
            fontFamily: 'Arimo, sans-serif'
          }}>
            <p style={{ boxSizing: 'inherit', margin: '0px 0px 1.8em' }}>This is an agreement between you and {domainName.toUpperCase()} for virtual private network communications services, related services and features. It is NOT a service for the commission of criminal acts. It is an anonymity and privacy service. You agree not to violate any laws of any jurisdiction you are originating from, or terminating into.</p>

            <p style={{ boxSizing: 'inherit', margin: '0px 0px 1.8em' }}>You agree to protect your user id / password and our system from unauthorized use. You are responsible for all actions that occur on our services where the login uses your user id / password.</p>

            <p style={{ boxSizing: 'inherit', margin: '0px 0px 1.8em' }}>You agree not to use the system for sending spam, port scanning, scanning for open proxies or open relays, sending opt-in email, unsolicited email or any type or version of email sent in large quantities even if the email and ultimately sent off of another server. You agree not to launch any pop-ups from our service. You agree not to attack in any way shape or form any other computer or network while on our service.</p>

            <p style={{ boxSizing: 'inherit', margin: '0px 0px 1.8em' }}>Actual service coverage, speeds, locations, and quality may vary. The service will attempt to be available at all times except for limited periods for maintenance and repair. However, the Service may be subject to unavailability for a variety of factors beyond our control including emergencies, third party service failures, transmission, equipment or network problems or limitations, interference, signal strength, and may be interrupted, refused, limited or curtailed. We are not responsible for data, messages or pages lost, not delivered, delayed or misdirected because of interruptions or performance issues with the Service or communications services or networks (e.g., T-1 lines or the Internet). We may impose usage or Service limits, suspend Service, or block certain kinds of usage in our sole discretion to protect users or the Service. Network speed is an estimate and is no indication of the speed at which your or the Service sends or receives data. Actual network speed will vary based on configuration, compression, network congestion and other factors. The accuracy and timeliness of data received is not guaranteed; delays or omissions may occur.</p>

            <p style={{ boxSizing: 'inherit', margin: '0px 0px 1.8em' }}>We do not log any user activity (sites visited, DNS lookups, emails etc.) We only log access attempts to our servers (for security and troubleshooting). We do not get involved in any form of censorship. We do not give your personal information to any third parties. We do not cooperate with any requests for information unless we are ordered by a court of competent jurisdiction and the vast majority of these requests would not be from a court of competent jurisdiction. We will protect you to the max and our system is set-up to automatically do so. There are hundreds of good reasons for being anonymous and we respect them fully.</p>

            <h2 style={{ boxSizing: 'inherit', margin: '0px 0px 0.4em', fontSize: '20px', lineHeight: '1.8', fontFamily: 'Arimo, sans-serif', fontWeight: 'bold' }}>Cancellation</h2>
            <p style={{ boxSizing: 'inherit', margin: '0px 0px 1.8em' }}>Because this is a prepaid one-time purchase, there is no recurring plan to cancel and no future charges to stop. Unused time remaining in a paid period is not refunded if you stop using the service before the period ends.</p>

            <h2 style={{ boxSizing: 'inherit', margin: '0px 0px 0.4em', fontSize: '20px', lineHeight: '1.8', fontFamily: 'Arimo, sans-serif', fontWeight: 'bold' }}>Refunds</h2>
            <p style={{ boxSizing: 'inherit', margin: '0px 0px 1.8em' }}>By completing checkout, or by accepting, downloading, installing, or otherwise accessing the software or credentials, you acknowledge that your purchase is final and NON-REFUNDABLE except where required by applicable law. Once digital access has been delivered, no refunds, credits, or cancellations will be permitted except where that law requires otherwise.</p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default TermsOfService;
